<div class="login-bg four-o-four-bg animated fadeIn" style="overflow: hidden;">
  <div class="container">
    <div class="ui-g-12" style="margin-top:20%;">
      <div class="ui-lg-6 ui-md-6 ui-md-offset-8">
        <div class="ui-g-12">
          <!--<div class="tiger-logo animated fadeIn">-->
          <!--</div>-->
          <div class="ui-g-12 lost-header animated fadeIn">
            <h1>404</h1>
            <h2>Looks like you're in trouble</h2>
          </div>
          <div class="ui-g-12 lost-text animated fadeIn">
            <p>You will be redirected to the login page in <u><strong>{{countDown}} seconds</strong></u>.</p>
          </div>
          <div class="ui-g-12 lost-btn login-wrap animated fadeIn">
            <a class="login-btn" href="/login">Go Home <i class="fal fa-arrow-circle-right" style="padding-left:15px;"></i></a>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>